/**
 * 步骤进度条组件
 * 显示当前操作的进度和步骤
 * 
 * @component StepsBar
 * @props {Number} currentStep - 当前步骤的索引值(从0开始)
 * @props {Array} steps - 步骤列表，每个元素包含 title 和 description 属性
 */

<template>
  <el-steps 
    :active="currentStep" 
    finish-status="success"
    class="writing-steps"
    simple
  >
    <el-step
      v-for="(step, stepIndex) in steps"
      :key="stepIndex"
      :title="step.title"
      :description="step.desc"
      :class="{
        'active-step': currentStep === stepIndex,
        'prev-step': currentStep > stepIndex
      }"
      @click="handleStep(stepIndex, step)"
    >
      <template #icon>
        <el-icon>
          <svg-icon v-if="currentStep >= stepIndex" name="progress-active" />
          <svg-icon v-else name="progress" />
        </el-icon>
      </template>
    </el-step>
  </el-steps>
</template>

<script setup>
import { EditPen, CircleCheckFilled } from '@element-plus/icons-vue'

defineProps({
  currentStep: {
    type: Number,
    required: true
  }
})

const emits = defineEmits(['change'])
const steps = [
  { title: '内容录入', desc: '填写基本信息'},
  { title: '要点提纲', desc: '生成提纲要点'},
  { title: '初版生成', desc: '生成初始文档'},
  { title: '确稿留存', desc: '确认并保存'},
]

const handleStep = (index, info) => {
  emits('change', index, info)
}

</script>

<style scoped lang="scss">
.writing-steps {
  padding: 16px 24px;
  width: 100%;
  gap: 1px;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 1px solid #E0E0E0;
  :deep(.el-step.is-simple) {
    flex: 1 !important;
    height: 42px;
    justify-content: center;
    background-image: url('@/assets/icons/steps/normal.svg');
    background-size: 100% 100%;
    &:first-child {
      background-image: url('@/assets/icons/steps/left.svg');
    }
    &:last-of-type.is-flex {
      flex: 1 !important;
      max-width: none !important;
      background-image: url('@/assets/icons/steps/right.svg');
    }

    &.active-step {
      // cursor: pointer;
      background-image: url('@/assets/icons/steps/normal-active.svg');
      &:first-child {
        background-image: url('@/assets/icons/steps/left-active.svg');
      }
      &:last-child {
        background-image: url('@/assets/icons/steps/right-active.svg');
      }
    }

    &.prev-step {
      cursor: pointer;
      &:hover {
        background-image: url('@/assets/icons/steps/normal-active.svg');
        &:first-child {
          background-image: url('@/assets/icons/steps/left-active.svg');
        }
        &:last-child {
          background-image: url('@/assets/icons/steps/right-active.svg');
        }
      }
    }

    .el-step__head {
      .el-step__icon {
        width: 18px;
        height: 18px;
        font-size: 18px;
      }
    }

    .el-step__main {
      max-width: fit-content;
      white-space: nowrap;
      .el-step__arrow {
        display: none;
      }
      .el-step__title {
        max-width: 100% !important;
        font-size: 14px;
        font-weight: 600;
        color: #999;
        &.is-success,
        &.is-process {
          color: #222;
        }
      }
    }
  }
}

:deep(.el-step.is-active .el-step__icon) {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(26, 26, 26, 0.2);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(26, 26, 26, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(26, 26, 26, 0);
  }
}

</style> 